import { GlButton, GlTooltipDirective, GlIcon, GlAnimatedLoaderIcon } from '@gitlab/ui';
import { TYPE_ISSUE } from '~/issues/constants';
import { BV_HIDE_TOOLTIP } from '~/lib/utils/constants';
import { __, s__ } from '~/locale';
import { createAlert } from '~/alert';
import { userTypes } from '../assignees/constants';
import ReviewerAvatarLink from './reviewer_avatar_link.vue';
const LOADING_STATE = 'loading';
const SUCCESS_STATE = 'success';
const JUST_APPROVED = 'approved';
const REVIEW_STATE_ICONS = {
    APPROVED: {
        name: 'check-circle',
        iconClass: 'gl-fill-icon-success',
        title: s__('MergeRequest|Reviewer approved changes')
    },
    REQUESTED_CHANGES: {
        name: 'error',
        iconClass: 'gl-fill-icon-danger',
        title: s__('MergeRequest|Reviewer requested changes')
    },
    REVIEWED: {
        name: 'comment-lines',
        iconClass: 'gl-fill-icon-info',
        title: s__('MergeRequest|Reviewer commented')
    },
    UNREVIEWED: {
        name: 'dash-circle',
        iconClass: 'gl-fill-icon-default',
        title: s__('MergeRequest|Awaiting review')
    },
    REVIEW_STARTED: {
        name: 'comment-dots',
        iconClass: 'gl-fill-icon-default',
        title: s__('MergeRequest|Reviewer started review')
    }
};
export default {
    name: 'UncollapsedReviewerList',
    i18n: {
        reRequestReview: __('Re-request review'),
        removeReviewer: s__('MergeRequest|Remove reviewer')
    },
    components: {
        GlButton,
        GlIcon,
        GlAnimatedLoaderIcon,
        ReviewerAvatarLink
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        users: {
            type: Array,
            required: true
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: false
        },
        canRerequest: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'remove-reviewer',
        'request-review'
    ],
    data () {
        return {
            loadingStates: {}
        };
    },
    watch: {
        users: {
            handler (users, previousUsers) {
                this.loadingStates = users.reduce((acc, user)=>({
                        ...acc,
                        [user.id]: acc[user.id] || null
                    }), this.loadingStates);
                if (previousUsers) {
                    users.forEach((user)=>{
                        const userPreviousState = previousUsers.find(({ id })=>id === user.id);
                        if (userPreviousState && user.mergeRequestInteraction.approved && !userPreviousState.mergeRequestInteraction.approved) {
                            this.showApprovalAnimation(user.id);
                        }
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        showApprovalAnimation (userId) {
            this.loadingStates[userId] = JUST_APPROVED;
            setTimeout(()=>{
                this.loadingStates[userId] = null;
            }, 1500);
        },
        reRequestReview (userId) {
            this.loadingStates[userId] = LOADING_STATE;
            this.$root.$emit(BV_HIDE_TOOLTIP);
            this.$emit('request-review', {
                userId,
                callback: this.requestReviewComplete
            });
        },
        removeReviewer (userId) {
            this.loadingStates[userId] = LOADING_STATE;
            this.$emit('remove-reviewer', {
                userId,
                done: ()=>this.requestRemovalComplete(userId)
            });
        },
        requestReviewComplete (userId, success, errorMessage) {
            if (success) {
                this.loadingStates[userId] = SUCCESS_STATE;
                setTimeout(()=>{
                    this.loadingStates[userId] = null;
                }, 1500);
            } else {
                this.loadingStates[userId] = null;
                if (errorMessage) {
                    createAlert({
                        message: errorMessage
                    });
                }
            }
        },
        requestRemovalComplete (userId) {
            delete this.loadingStates[userId];
        },
        reviewStateIcon (user) {
            if (user.mergeRequestInteraction.approved) {
                return {
                    ...REVIEW_STATE_ICONS.APPROVED,
                    class: [
                        this.loadingStates[user.id] === JUST_APPROVED && 'merge-request-approved-icon'
                    ]
                };
            }
            return REVIEW_STATE_ICONS[user.mergeRequestInteraction.reviewState] || REVIEW_STATE_ICONS.UNREVIEWED;
        },
        isDuoCodeReviewInProgress (user) {
            return user.type === userTypes.duo_code_review_bot && user.mergeRequestInteraction.reviewState === 'REVIEW_STARTED';
        },
        showRequestReviewButton (user) {
            if (this.canRerequest) {
                if (!user.mergeRequestInteraction.approved) {
                    if (this.isDuoCodeReviewInProgress(user)) {
                        return false;
                    }
                    return ![
                        'UNREVIEWED'
                    ].includes(user.mergeRequestInteraction.reviewState);
                }
                return true;
            }
            return false;
        }
    },
    LOADING_STATE,
    SUCCESS_STATE
};
